import React from 'react';
import styles from './Button.module.css';

interface IButton {
  type?: 'primary' | 'default' | 'transparent';
  text: string;
  onClick: (e?: any) => void;
  children?: JSX.Element;
  className?: string;
  qaMarker?: string;
  addStyles?: React.CSSProperties;
  disabled?: boolean;
}

const Button = ({
  type = 'primary',
  text,
  onClick,
  className,
  qaMarker,
  addStyles,
  disabled,
  children,
}: IButton) => {
  const handleClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    onClick();
  };

  const typeBtn =
    type === 'primary'
      ? styles.button_primary
      : type === 'default'
      ? styles.button_default
      : styles.button_transparent;

  return (
    <button
      onClick={handleClick}
      className={`${styles.button} ${typeBtn} ${className ? className : ''}`}
      style={addStyles}
      disabled={disabled}
      data-qa-marker={qaMarker}
    >
      {text}
      {children}
    </button>
  );
};

export default Button;
